"use client";

import { SpotlightAnchor } from "@/component/NewUserGuide/SpotlightAnchor";
import { useSpotlight } from "@/component/NewUserGuide/SpotlightContext";
import { SpotlightPopover } from "@/component/NewUserGuide/SpotlightPopover";
import { useEffect } from "react";
import { CommunityList } from "./CommunityList";

export const CommunitySection = () => {
  const { activeStep, completeGuide } = useSpotlight();

  useEffect(() => {
    if (activeStep === 3) {
      const el = document.getElementById("community-section");
      if (el && window) {
        const rect = el.getBoundingClientRect();
        const targetTop = rect.top - 400;
        window.scrollTo({
          top: targetTop,
          behavior: "smooth",
        });
      }
    }
  }, [activeStep]);

  return (
    <SpotlightAnchor
      step={3}
      margin={24}
      rounded="36px"
      gradientWidth={400}
      gradientHeight={150}
      popover={
        <SpotlightPopover
          currentStep={3}
          totalSteps={3}
          onNext={() => {
            completeGuide();
          }}
          onClose={completeGuide}
          videoUrl="https://static.sandcdn.com/uploads/cbc5cf09-6604-46f6-accb-798d854f4137.mp4"
          posterUrl="https://static.sandcdn.com/uploads/22a82034-0aff-4b46-8deb-87bdb0d5b5cc.jpg"
          buttonText="Start now"
          className="-top-[320px] left-1/2 -translate-x-1/2"
          content={<>Explore community works and remix in action.</>}
        />
      }
    >
      <section id="community-section" className="flex flex-col gap-5">
        <h2 className="text-text-primary font-bold text-xl">
          From the Community
        </h2>
        <CommunityList />
      </section>
    </SpotlightAnchor>
  );
};
